import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RouterUtilityService {
  public substituteParams( activeRoute: ActivatedRoute, params: any ): any[] {
    let result: string[] = [ '/' ];
    for( var i = 0; i < activeRoute.pathFromRoot.length; i++ ) {
      var snapshot = activeRoute.pathFromRoot[ i ].snapshot;
      var existingParams = snapshot.params;

      var routeConfig = snapshot.routeConfig;

      if( routeConfig ) {
        var path = routeConfig.path;

        if( path ) {
          var segments = path.split( '/' );

          segments = segments.map( s => {
            if( s[ 0 ] !== ':' ) {
              return s;
            } 

            var paramId = s.substring( 1 );

            if( paramId in params ) {
              return params[ paramId ];
            } else {
              return existingParams[ paramId ];
            }
          });

          result = result.concat( segments );
        }
      }
    }
    
    return result;
  }

  constructor () {

  }
} 
